// src/app/services/date-range.service.ts
import { Injectable } from '@angular/core';
import * as moment from 'moment';

export type DateRangeOption =
  | 'today'
  | 'yesterday'
  | 'last7'
  | 'last30'
  | 'thisMonth'
  | 'lastMonth'
  | 'fiscal'
  | 'custom';

export interface DateRange {
  fromDate: Date | null;
  toDate: Date | null;
}

@Injectable({
  providedIn: 'root'
})
export class DateRangeService {
  getDateRange(option: DateRangeOption): DateRange {
    const today = moment();
    let fromDate: Date | null = null;
    let toDate: Date | null = null;

    switch (option) {
      case 'today':
        fromDate = today.clone().startOf('day').toDate();
        toDate = today.clone().endOf('day').toDate();
        break;

      case 'yesterday':
        fromDate = today.clone().subtract(1, 'day').startOf('day').toDate();
        toDate = today.clone().subtract(1, 'day').endOf('day').toDate();
        break;

      case 'last7':
        fromDate = today.clone().subtract(6, 'days').startOf('day').toDate();
        toDate = today.clone().endOf('day').toDate();
        break;

      case 'last30':
        fromDate = today.clone().subtract(29, 'days').startOf('day').toDate();
        toDate = today.clone().endOf('day').toDate();
        break;

      case 'thisMonth':
        fromDate = today.clone().startOf('month').toDate();
        toDate = today.clone().endOf('month').toDate();
        break;

      case 'lastMonth':
        fromDate = today.clone().subtract(1, 'month').startOf('month').toDate();
        toDate = today.clone().subtract(1, 'month').endOf('month').toDate();
        break;

      case 'fiscal':
        const fiscalStart = today.month() < 3
          ? today.clone().subtract(1, 'year').month(3).startOf('month')
          : today.clone().month(3).startOf('month');
        const fiscalEnd = fiscalStart.clone().add(1, 'year').subtract(1, 'day');
        fromDate = fiscalStart.toDate();
        toDate = fiscalEnd.toDate();
        break;

      case 'custom':
        fromDate = null;
        toDate = null;
        break;
    }

    return { fromDate, toDate };
  }
}
